import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { first } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from 'src/app/core/services/user.service';


@Component({
  selector: 'app-set-new-password',
  templateUrl: './set-new-password.component.html',
  styleUrls: ['./set-new-password.component.scss']
})
export class SetNewPasswordComponent implements OnInit {
  newPassword: string;
  oldPassword: string;
  error = '';
  loading = false;
  SetPassword: FormGroup;
  submitted: boolean=false;
  showerror: boolean=false;
  showerror1: boolean=false;
  token: any;
  show: boolean=false;
  type = "password";
  show1: boolean=false;
  type1 = "password";
  isGoToChangePasswordScreen: any=false;
  emailUser: any;
  constructor(public auth:AuthenticationService,
    private formBuilder: FormBuilder,
    private router:Router,
    public route: ActivatedRoute,
    public user:UserService) 
    { 
      this.route.queryParams.subscribe((res) => {
        this.token=res.token;
      //  console.log(this.token)
      });
    }

  ngOnInit(): void {
    this.SetPassword = this.formBuilder.group({
      newPassword: ['', [Validators.required,Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,15}$") ]  ],
      // newPassword: ['', [Validators.required,Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$])(?=.{8,20})/)]],
      confirmPassword: ['', [Validators.required,Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).{8,15}$") ]  ],
      // confirmPassword: ['', [Validators.required,Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+_=)/()]).{8,15}$") ]  ],
      // confirmPassword: ['', [Validators.required,Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*#?&+-/])[A-Za-z\d$@$!%*#?&].{7,16}') ]  ],
     });
     this.submitted = true;
     this.error="";
     this.verifyToken();
  }
  get f(){
    return this.SetPassword.controls;
}
test(){
    
  this.showerror=false
  this.showerror1=false
  this.error="";
      //  if(this.SetPassword.invalid){
        // if(this.f.newPassword.value!=this.f.confirmPassword.value){
        //   this.error="“New Password” and “Confirm Password” do not match.​";
        // }
        if(this.f.newPassword?.errors!==null)
        {
          this.error="Password is required";
          this.showerror=true
        }
        else{
          this.showerror=false;
        }
        if(this.f.confirmPassword?.errors!==null)
        {
          this.showerror1=true;
        }
        else{
          this.showerror1=false;
        }
      
      // }
    
}
updatePassword(){
    //
  this.emailUser=sessionStorage.getItem("loginUserEmail")
  this.isGoToChangePasswordScreen=sessionStorage.getItem("isGoToChangePasswordScreen")
  this.submitted = true;
    // this.error="";
       
    // if(this.f.newPassword.value!=this.f.confirmPassword.value){
    //   this.error="“New Password” and “Confirm Password” do not match.​";
    // }
//     this.showerror=false
// this.showerror1=false
//      if(this.SetPassword.invalid){
//       if(this.f.newPassword.errors.required)
//       {
//         this.error="Please check the password format!";
//       }
//       else{
//         this.showerror=true;
//       }
//       if(this.f.confirmPassword.errors.required)
//       {

//       }
//       else{
//         this.showerror1=true;
//       }
//     }
    if(this.f.newPassword.value!=this.f.confirmPassword.value){
      this.error="“New Password” and “Confirm Password” do not match.​";
      this.submitted = false;
      this.loading = false;
    }
    else{
 
    
    if(this.showerror==false && this.showerror1==false && this.error==""){
      if(this.isGoToChangePasswordScreen==false || this.isGoToChangePasswordScreen==null){
      this.error="";
      this.loading = true;
      this.user.setnewPassword(this.f.newPassword.value, this.f.confirmPassword.value,this.token)
      .pipe(first())
      .subscribe(
          data => {
            if(data.success==true){
              this.router.navigateByUrl('/login')
             //  this.router.navigateByUrl('/home/steps-status')
               Swal.fire('','Password updated successfully.','success')
             }
             else{
              this.loading = false;
              this.submitted = false;
               Swal.fire('',data.data,'error')
             }
          },error=>{
            //  if(this.baseservice.handleError(error)){
               //handle Exception from Server 404,401
              if(error.status == 400 || error.status==417){
                  this.error=error.error.data;
                  this.loading = false;
                  this.submitted = false;
               }
               else{
                  this.loading = false;
                  this.submitted = false;

                 this.error="Something went wrong. Please refresh the page and try again.";
               }
           //  }
              },()=>{});
            }
          
          else{
            this.error="";
            this.loading = true;
            this.user.changeUserPassword(this.emailUser,this.f.newPassword.value, this.f.confirmPassword.value,this.token)
            .pipe(first())
            .subscribe(
                data => {
                  
                  // if(data.success==false){
                  //   Swal.fire('',data.data,'error')
                  //  }
                  //  else{
                  //   localStorage.setItem('currentToken', JSON.stringify(data.accessToken));
                  //   if(data && data.accessToken){
                  //     sessionStorage.setItem('currentUserBroker', JSON.stringify(data));
                  //     localStorage.setItem('refreshtoken',data.refreshToken)
                  //      this._userSubject.next(data);
                      
                  //     // this.startRefreshTokenTimer();
                  //        var flag =false;
                  //        for(var i=0;i<data.roles.length;i++)
                  //        {
                  //          if(data.roles[i].role=="ROLE_LEAD_BROKER")
                  //          {
                  //            flag=true;
                             
                  //          }
                  //          sessionStorage.setItem('leadMgaId',data.roles[i].id)
                  //        }
                  //        let daa=''+flag;
                  //        sessionStorage.setItem('flag', daa);
                  //        let name=data.userProfile.firstName+" "+data.userProfile.lastName;
                  //        sessionStorage.setItem('username', name);
                  //        this.getLoggedInName.emit(data);
       
                  //    }
                  //   this.flag =sessionStorage.getItem('flag');
                  //   //  if(this.flag == "true"){
                  //      if(data.firstTime){
                  //       this.router.navigateByUrl('/home/steps-status');
                  //      }else{ 
                  //       this.appService.setUserLoggedIn(true);
                  //       // this.router.navigateByUrl('/dashboard/personal-info');}
                  //       sessionStorage.setItem("leadEmailInfo", JSON.stringify(data.userProfile.email));
                  //       sessionStorage.setItem("loggedInphoneNumber", JSON.stringify(data.userProfile.phoneNumber))
                  //       this.getDashboard();
                  //      }
                  //       //   }else if(this.flag == "false"){
                  //       // this.error="The email address entered is not registered with this portal."
                  //       // this.loading = false;
                  //       //  }else{
                  //       //   this.error="Please check your email and password!"
                  //       //   this.loading = false;
                  //       //  }
                  //       }
                  if(data.success==false){
                    Swal.fire('',data.data,'error')
                    this.submitted = false;
                    this.loading = false;
                   }
                   else{
                    sessionStorage.setItem('username1',this.emailUser);
                    this.router.navigateByUrl('/login')
                   //  this.router.navigateByUrl('/home/steps-status')
                     Swal.fire('','Password updated successfully.','success')
                   }
                },error=>{
                  //  if(this.baseservice.handleError(error)){
                     //handle Exception from Server 404,401
                    if(error.status == 400 || error.status==417){
                        this.error=error.error.data;
                        this.loading = false;
                        this.submitted = false;
                     }
                     else{
                        this.loading = false;
                        this.submitted = false;
      
                       this.error="Something went wrong. Please refresh the page and try again.";
                     }
                 //  }
                    },()=>{});
                  }
                }
                else{
                  this.submitted = false;
                }
                }
    }
    toggleShow() {
      this.show = !this.show;
      if (this.show) {
        this.type = "text";
      }
      else {
        this.type = "password";
      }
    }
    toggleShow1() {
      this.show1 = !this.show1;
      if (this.show1) {
        this.type1 = "text";
      }
      else {
        this.type1 = "password";
      }
    }
    verifyToken(){
      this.user.verifyToken(this.token,true,true).pipe()
      .subscribe(
        data => {
          if(data.data=='false'){
          }else{
            this.router.navigateByUrl('/login')
          }
        }, error => {
        }, () => { });
    }
  }

